'use strict';

angular.module('atex.dam').controller('DamAssignController', [ '$scope', 'AssignService', 'ContentService', 'DamService', '$translate', 'DamNotificationService',
function($scope, AssignService, ContentService, DamService, $translate, DamNotificationService) {

  $scope.panelTitle = $translate.getTranslationTable().__ASSIGN_CONTENT__;
  $scope.dbusers = undefined;
  $scope.userIsOwner = undefined;
  $scope.showSpinner = true;
  $scope.initialOwners = [];
  $scope.isDirty = false;
  $scope.isSaving = false;
  $scope.content = undefined;
  $scope.userIsCreator = undefined;
  $scope.currentUserId = undefined;
  $scope.creatorUserId = undefined;

  var contentAssignees;
  
  var decorateUsers = function(currentUserInfo, users) {
      $scope.currentUserId = currentUserInfo.externalId;
      for (var i = 0; i < users.length; i++) {
        if($scope.creatorUserId && users[i].principalId===$scope.creatorUserId) {
          users[i]['isCreator'] = true;
        } else {
          users[i]['isCreator'] = false;
        }
        var isActual = false;
        var currentExtId = users[i].principalId;
        if (!$scope.userIsOwner) {
          isActual = currentUserInfo.externalId === currentExtId;
          if (!isActual && currentExtId.indexOf('group') === 0) {
            var group = AssignService.findGroupById(currentUserInfo.groups, currentExtId);
            if (group) {
              isActual = true;
            }
          }
        }
        var assignee = AssignService.findAssigneeById(contentAssignees, currentExtId);
        if (assignee) {
          users[i]['isAssignee'] = true;
          users[i]['owner'] = assignee.owner;
          if (assignee.owner) {
            if (!$scope.userIsOwner && isActual) {
              $scope.userIsOwner = true;
            }
            $scope.initialOwners.push(users[i]);
          }
        } else {
          users[i]['isAssignee'] = false;
          users[i]['owner'] = false;
        }
      }
      // After decoration, check if we need permission
      if (!$scope.userIsOwner && currentUserInfo.isAdm) {
        console.log("User is admin");
        $scope.userIsOwner = true;
      }
  };

  DamService.getCurrentDamUserInfo().then(function(currentUserInfo) {
        return ContentService.getContent({id : $scope.id}).then(function(response) {
          var contentName = response.data.aspects.contentData.data.name;
          var titlePostfix = contentName ? contentName : response.id;
          $scope.panelTitle = $scope.panelTitle + " " + titlePostfix;
          $scope.content = response;
          var creator = response.data.aspects['atex.dam.standard.ContentAccess'].data.creator;
          $scope.userIsCreator = creator && creator === currentUserInfo.externalId;
          $scope.creatorUserId = creator;
          contentAssignees = response.data.aspects['atex.dam.standard.ContentAccess'].data.assignees;

          DamService.getUsersAndGroups().then(function (users) {
            decorateUsers(currentUserInfo, users);
            $scope.dbusers = users;
            $scope.showSpinner = false;
          });
        });
  }).catch(function (error) {
    $scope.showSpinner = false;
    console.log('ERROR: Getting content:', error);
    DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: error}), true);
  });

  $scope.toggleSelection = function(user) {
    if (user === undefined) {
      return;
    }
    if (!$scope.userIsOwner) {
      return;
    }
    if (!$scope.userIsCreator) {
        if ($scope.initialOwners.indexOf(user) >= 0) {
          return;
        }
    } else if (user.isCreator) {
      return;
    }
    user.isAssignee = !user.isAssignee;
    if (!user.isAssignee) {
      user.owner = false;
    }
    $scope.isDirty = true;
  };

  $scope.toggleOwner = function(user) {
    if (user === undefined) {
      return;
    }
    if (!$scope.userIsOwner) {
      return;
    }
    if (!$scope.userIsCreator) {
      if ($scope.initialOwners.indexOf(user) >= 0) {
        return;
      }
    } else if (user.isCreator) {
      return;
    }
    user.owner = !user.owner;
    $scope.isDirty = true;
  };

  $scope.doSave = function() {
    if ($scope.dirty === false) {
      $scope.$parent.doCancel();
      return;
    }
    $scope.isSaving = true;
    var assignees = [];
    for (var i = 0; i < $scope.dbusers.length; i++) {
      if ($scope.dbusers[i].isAssignee === true) {
        assignees.push({
          'externalId' : $scope.dbusers[i].principalId,
          'owner' : $scope.dbusers[i].owner
        });
      }
    }
    $scope.content.data.aspects['atex.dam.standard.ContentAccess'].data.assignees = assignees;
    delete $scope.content.data.aspects['atex.dam.standard.ContentAccess'].data.assignees_element_types;
    var updateInfo = { id: $scope.content.id, data: $scope.content.data, revision: $scope.content.revision};
    ContentService.updateContent(updateInfo).then(function(response) {
      $scope.$parent.doOk(response);
      $scope.isSaving = false;
    }).then(null, function(error) {
      alert("ERROR saving assignees!");
      $scope.isSaving = false;
    });
  };

} ]);
